import styled from "styled-components";
import theme from "../../theme/theme";

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin-top: 0;
  color: #000;
  font-family: "Inter", sans-serif;
`;

export const Table = styled.table`
  width: 90%;
  border-collapse: collapse;
`;

export const TableRow = styled.tr``;

export const TableCell = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
`;

export const AttributeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AttributeName = styled.span`
  color: #777;
  font-size: 14px;
`;

export const AttributeValue = styled.span<{disabled?: boolean}>`
  color: ${props => (props.disabled ? theme.color.silver  : theme.color.black)};
  font-size: 18px;
  margin-top: 5px;
  margin-left: 20px;
`;

export const EditButton = styled.span`
  text-decoration: underline;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    cursor: pointer;
    color: #0b3da5;
  }
  display: flex;
  justify-content: flex-end;
`;

export const EditButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TableContainer = styled.div`
  justify-content: center;
  display: flex;
`;

export const CardWrapper = styled.div`
  padding: 10px;
`;

export const NameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: 1024px) {
    gap: 0;
    flex-direction: column;
  }
`;

export const DeleteWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 30px 20px 0 0;
`;

export const CheklistWrapper = styled.div`
  margin-left: 20px;
  margin-bottom: 20px;
  color: #000;
`;

export const Card = styled.div`
  background-color: ${theme.color.white};
  border-radius: 14px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
  display: table;
  width: 90%;
  height: auto;
  min-height: 10em;
  padding: 30px;
  color: ${({ color }) => color ?? "#ffff"};
  font-family: "Inter", sans-serif;

  @media (max-width: 400px) {
    padding: 20px;
  }
`;


